const respostaCotacao = 'https://proxpect.freshdesk.com/support/solutions/articles/67000517907-como-responder-uma-cotac%C3%A3o-de-frete-via-cotac%C3%B5es-de-frete-';
const meuPainel = 'https://proxpect.freshdesk.com/support/solutions/articles/67000517888-o-que-%C3%A9-o-menu-meu-painel-';
const apresentacaoPremium = 'https://proxpect.freshdesk.com/support/solutions/articles/67000527039-apresentac%C3%A3o-do-painel-premium-do-m%C3%B3dulo-de-transporte';
const locaisColeta = 'https://proxpect.freshdesk.com/support/solutions/articles/67000527039-apresentac%C3%A3o-do-painel-premium-do-m%C3%B3dulo-de-transporte';
const negociacao = 'https://proxpect.freshdesk.com/support/solutions/articles/67000517923-como-responder-a-uma-negociac%C3%A3o-de-frete-';
const alterarProposta = 'https://proxpect.freshdesk.com/support/solutions/articles/67000517966-como-alterar-a-proposta-enviada-ao-embarcador-';
const criarConta = 'https://proxpect.freshdesk.com/support/solutions/articles/67000517871-como-se-cadastrar-na-proxpect-como-um-transportador-';
const geral = 'https://proxpect.freshdesk.com/support/solutions/folders/67000457675';
const aprovarContratacao = 'https://proxpect.freshdesk.com/support/solutions/articles/67000517968-como-aprovo-a-contratac%C3%A3o-de-frete-enviada-pelo-embarcador-';

export {
  respostaCotacao,
  meuPainel,
  apresentacaoPremium,
  locaisColeta,
  negociacao,
  alterarProposta,
  criarConta,
  geral,
  aprovarContratacao,
};
